import { useRef, useState, useMemo, useEffect } from "react";
import debounce from "lodash.debounce";

export default function useFormFactor() {
  const [windowWidth, setWindowWidth] = useState(window?.innerWidth ?? 1280);
  const [windowHeight, setWindowHeight] = useState(window?.innerHeight ?? 720);
  const orientation: "portrait" | "landscape" = useMemo(() => {
    return windowWidth > windowHeight ? "landscape" : "portrait";
  }, [windowWidth, windowHeight]);

  const onResize = useRef(
    debounce(async () => {
      if (window && window.innerWidth) setWindowWidth(window.innerWidth);
      if (window && window.innerHeight) setWindowHeight(window.innerHeight);
    }, 0)
  ).current;

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      onResize.cancel();
    };
  });

  const formFactor: "mobile" | "desktop" = useMemo(() => {
    // 768px is the breakpoint for mobile based on Tailwind Responsive Design
    if (windowWidth < 768) return "mobile";
    return "desktop";
  }, [windowWidth]);

  return { formFactor, windowWidth, windowHeight, orientation };
}
